// ШАБ.1: подгрузка полных данных карт из @data/cards-*.js.
//
// Сервер возвращает только { id, rarity, name_ru, faction } в open-pack.
// Полные статы (atk/armor/hp), keywords, ability_text, flavor — в данных.
// Этот хелпер кеширует объединённый пул в Map для быстрого lookup.

// @ts-ignore
import { cards as cardsDeus } from '@data/cards-deus.js';
// @ts-ignore
import { cards as cardsSyn } from '@data/cards-syntetics.js';
// @ts-ignore
import { cards as cardsGlb } from '@data/cards-global.js';
// @ts-ignore
import { cards as cardsLiv } from '@data/cards-livlife.js';
// @ts-ignore
import { cards as cardsNeutral } from '@data/cards-neutral.js';

export interface CardData {
  id: string;
  name_ru: string;
  name_en?: string;  // EN-имя из xlsx-колонки name_en (есть у всех 271 карты)
  faction: 'deus' | 'syntetics' | 'global' | 'livlife' | 'neutral';
  type: 'unit' | 'action' | 'mod' | 'influence';
  rarity: 'common' | 'rare' | 'epic' | 'legendary' | 'special';
  atk: number | null;
  armor: number | null;
  hp: number | null;
  keywords: string[];
  exclusive_hero: string | null;
  initiation?: number | null;
  ability_text?: {
    order?: string; trigger?: string; deathrattle?: string;
    active?: string; aura?: string;
  };
  ability_text_en?: {
    order?: string; trigger?: string; deathrattle?: string;
    active?: string; aura?: string;
  };
  flavor_ru?: string | null;
  priority?: string | null; // для будущих приоритетов атаки
}

const POOL: Map<string, CardData> = new Map();
for (const list of [cardsDeus, cardsSyn, cardsGlb, cardsLiv, cardsNeutral]) {
  for (const c of (list as CardData[])) POOL.set(c.id, c);
}

export function getCardData(id: string): CardData | null {
  return POOL.get(id) || null;
}

// ЗВЁЗДЫ.2 (Этап 76): пул id'шек по редкости — для наполнения ленты рулетки
// изъятия случайными картами-«антуражем» нужной редкости.
export function cardIdsByRarity(rarity: string): string[] {
  const out: string[] = [];
  for (const c of POOL.values()) {
    if (c.rarity === rarity && c.faction !== 'neutral') out.push(c.id);
  }
  return out;
}
